/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Model for an organization administrator updating the organization from Settings.
 * @export
 * @interface OrganizationUserUpdate
 */
export interface OrganizationUserUpdate {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserUpdate
     */
    license_key?: string | null;
}

/**
 * Check if a given object implements the OrganizationUserUpdate interface.
 */
export function instanceOfOrganizationUserUpdate(value: object): value is OrganizationUserUpdate {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function OrganizationUserUpdateFromJSON(json: any): OrganizationUserUpdate {
    return OrganizationUserUpdateFromJSONTyped(json, false);
}

export function OrganizationUserUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationUserUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'license_key': json['license_key'] == null ? undefined : json['license_key'],
    };
}

export function OrganizationUserUpdateToJSON(json: any): OrganizationUserUpdate {
    return OrganizationUserUpdateToJSONTyped(json, false);
}

export function OrganizationUserUpdateToJSONTyped(value?: OrganizationUserUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'license_key': value['license_key'],
    };
}

